import { computed } from 'vue';

import { useStore } from '@/composables/useVuexStore';

// TODO: Use enum that must be shared accross project (`shared` or `api`)
const ADMIN_ROLES = ['advert-admin', 'manager'] as const;

export const useIsAdmin = () => {
  const store = useStore();
  return computed(() => ADMIN_ROLES.includes(store.getters.role));
};
